<template>
  <apexchart :options="options" :series="series"></apexchart>
</template> 

<script>
import { useViewSelector } from "../../stores/viewSelector";
import { useUserStore } from '../../stores/user';
import { storeToRefs } from 'pinia';
import VueApexCharts from "vue3-apexcharts";
export default{
  name: 'barActiveCustomersChart',
  components:{
    apexchart: VueApexCharts,
  },
  setup() {
    const viewSelector = useViewSelector();
    const {currentView} = storeToRefs(viewSelector);
    
    const userStore = useUserStore();
    const {user_id, comp_id, isSessionExpired} = storeToRefs(userStore);
    const { trigSessVerify } = userStore;

    return {
      user_id,
      comp_id,
      currentView,      
      isSessionExpired,
      trigSessVerify,
    }
  },
  data(){
    return {
      options: {
        chart: {
          type:'bar',
          id: 'vueBarAtvCtmChart',
          width:'100%',
        },
        colors:['#7789A4','#0B9719','#BA2D0D'],
        xaxis: {
          type:'datetime',
          categories:[],
        },
        dataLabels:{
          enabled:false,
        },
        title: {
          text: "Clientes ativos",
        },
        responsive: [
          {
            breakpoint: 640,
            options: {
              chart: {
                toolbar: {
                  tools: {
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                  }
                },
              },
            }
          }
        ]
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
        },
      },
      noData:{
        text:'Loading...',
      },
      legend: {
        position: 'right',
        offsetY: 40,
      },
      series: [{
            name: 'Active Customers',
            data: []
          },
      ],
    }
  },  
  
  computed: {
    translation: function() {
      return ({
        title: this.$i18n.t("graphs.barACtms.title"),
        serie: this.$i18n.t("graphs.barACtms.serie"),
      })
    }
  },
  watch: {
    translation(t) {
      this.options = {
       ...this.options,
       ...{
          title: {
            text: t.title,
          },
        }
      }

      this.series[0].name = t.serie;
    }
  },
    
  mounted() {
    
    let url = process.env.VUE_APP_URL + '/activeCustomers';
    let nB = {u_id:this.user_id ,c_id:this.comp_id }
    fetch(url, {
      method:'POST',
      body:JSON.stringify(nB),
      headers: new Headers({
        "content-type":"application/json"
      })
    })
    .then((res) =>res.json())
    .then((content) => {
      console.table(content);
      if(content.invalidSession){
        this.currentView = 'Login';
      }else{
        let x = [].concat(...content.activeCustomers[0].chart_data.data).map(({date})=>date);
        let y = [].concat(...content.activeCustomers[0].chart_data.data).map(({id})=>id);


        this.options = {
        ...this.options,
        ...{
            xaxis:{
              categories: x 
            },
            title: {
              text: this.translation.title,
            },
          }
        }

        this.series[0].data = y;
        this.series[0].name = this.translation.serie;
      }
    })
    .catch((err) => {console.log('Erro, '+err)});
    
  }, 
}
</script>


<style>
</style>
